import { APIClient } from './APIClient'


export class Lead { 
    private apiClient = new APIClient("/lead")

    public async createLead(params: {
        email: string
    }) { 
        this.apiClient.post({
            requestBody: params
        })
    }
}